// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MITs
import { SponsoredEvents } from './sponsored-events';
import { EventsAttendees } from './events-attendees';

export interface EventDetails {
  sponsoring: SponsoredEvents;
  attending: EventsAttendees;
}
